<template>
  <el-form
    ref="form"
    class="settings"
    label-width="80px"
    :model="submitData"
    :rules="rules"
  >
    <el-row>
      <el-col
        class="main"
        v-for="(item, key) in formData"
        :key="key"
        :span="item.md || 24"
      >
        <el-form-item
          :label="`${item.title ? item.title + '：' : ' '}`"
          :prop="key"
          v-if="item.show != null ? item.show : true"
          :class="{
            rich: item.type == 'rich',
          }"
          class="btns"
        >
          <template v-if="item.type == 'input'">
            <el-input
              v-model="submitData[key]"
              :placeholder="
                item.placeholder && !item.disabled ? item.placeholder : ''
              "
              :type="item.inputType || 'text'"
              :disabled="item.disabled"
            >
              <template v-if="item.icon" slot="prepend">
                {{ item.icon }}
              </template>
            </el-input>
          </template>
          <template v-if="item.type == 'textarea'">
            <el-input
              type="textarea"
              v-model="submitData[key]"
              :rows="item.rows || 2"
              :placeholder="
                item.placeholder && !item.disabled ? item.placeholder : ''
              "
              clearable
              resize="none"
              :disabled="item.disabled"
            ></el-input>
          </template>
          <template v-if="item.type == 'select'">
            <el-select
              v-model="submitData[key]"
              :placeholder="
                item.placeholder && !item.disabled ? item.placeholder : ''
              "
              :disabled="item.disabled"
              :popper-append-to-body="false"
              :filterable="item.selectCreate ? item.selectCreate : false"
              :allow-create="item.selectCreate ? item.selectCreate : false"
              @change="item.change ? item.change : null"
            >
              <el-option
                v-for="x in item.options"
                :key="x.id"
                :label="x.name"
                :value="x.id"
              ></el-option>
            </el-select>
          </template>
          <template v-if="item.type == 'checkbox'">
            <el-checkbox
              v-model="submitData[key]"
              :disabled="item.disabled"
            ></el-checkbox>
          </template>
          <template v-if="item.type == 'radio'">
            <el-radio-group
              v-model="submitData[key]"
              :disabled="item.disabled"
              @input="item.input"
            >
              <!-- <el-option
                v-for="x in item.options"
                :key="x.id"
                :label="x.name"
                :value="x.id"
              ></el-option> -->
              <el-radio v-for="x in item.options" :key="x.id" :label="x.id">{{
                x.name
              }}</el-radio>
              <!-- <el-radio :label="6">备选项</el-radio>
              <el-radio :label="9">备选项</el-radio> -->
            </el-radio-group>
          </template>
          <template v-if="item.type == 'button'">
            <el-button
              type="primary"
              :icon="item.icon"
              :disabled="item.disabled"
              @click="item.click"
              >{{ item.buttonTitle }}</el-button
            >
          </template>
          <template v-if="item.type == 'upload'">
            <el-upload
              action=""
              res="upload"
              :accept="item.accept ? item.accept : null"
              :http-request="item.httpRequest ? item.httpRequest : null"
              :before-upload="item.beforeUpload ? item.beforeUpload : null"
              multiple
              :show-file-list="false"
            >
              <el-button type="primary">{{ item.buttonTitle }}</el-button>
            </el-upload>
          </template>

          <template v-if="item.type == 'switch'">
            <el-switch
              v-model="submitData[key]"
              active-color="#2ab7ff"
              inactive-color="#f56c6c"
            >
            </el-switch>
          </template>
          <template v-if="item.type == 'rich'">
            <Editor v-model="submitData[key]" :toolbar="item.toolbar"></Editor>
          </template>
          <template v-if="item.type == 'text'">
            <span style="color:#fff">{{ item.text }}</span>
          </template>
          <template v-if="item.type == 'cascader'">
            <el-cascader
              v-model="submitData[key]"
              :options="item.options"
              :props="{
                label: item.propsLabel ? item.propsLabel : 'title',
                value: item.propsValue ? item.propsValue : 'value',
                multiple: item.multiple,
                emitPath: false,
                checkStrictly: item.checkStrictly ? item.checkStrictly : false,
              }"
              clearable
              collapse-tags
              leaf="modelColor"
              :show-all-levels="false"
              :disabled="item.disabled"
              @change="item.change"
              style="width: 99%;"
            ></el-cascader>
          </template>
          <template v-if="item.type == 'slider'">
            <el-slider
              v-model="submitData[key]"
              :max="item.max"
              :min="item.min"
              :step="item.step"
              @input="item.input"
            ></el-slider>
          </template>
          <template v-if="item.type == 'daterange'">
            <el-date-picker
              v-model="submitData[key]"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :disabled="item.disabled"
              :picker-options="{
                disabledDate: (date) => {
                  let disabled = false;
                  if (item.disabledDate)
                    switch (item.disabledDate.length) {
                      case 2:
                        disabled =
                          date.getTime() <
                            new Date(item.disabledDate[0]).getTime() ||
                          date.getTime() >
                            new Date(item.disabledDate[1]).getTime();
                        break;
                      case 1:
                        disabled =
                          date.getTime() <
                          new Date(item.disabledDate[0]).getTime();
                        break;
                      default:
                        disabled = false;
                    }
                  return disabled;
                },
              }"
            >
            </el-date-picker>
          </template>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item class="btns">
      <div class="flexRight btns">
        <el-button @click="close">取消</el-button>
        <el-button v-if="submit" type="primary" @click="onSubmit"
          >确定</el-button
        >
      </div>

      <!-- <el-button type="primary" @click="onSubmit">确认提交</el-button> -->
    </el-form-item>
  </el-form>
</template>
<script>
const Editor = () => import("@/components/common/imcoderTinymce/Index");
export default {
  name: "map-from",
  components: { Editor },
  props: {
    formData: Object,
    submitData: Object,
    rules: Object,
    submit: Function,
    close: Function,
  },
  data() {
    return {};
  },
  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {
    //一个对象，键是需要观察的表达式，值是对应回调函数。
    //值也可以是方法名，或者包含选项的对象。
    //Vue 实例将会在实例化时调用 watch()，遍历 watch 对象的每一个 property。
  },
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  mounted() {
    //实例被挂载后调用，这时 el 被新创建的 vm.el 替换了。如果根实例挂载到了一个文档内的元素上，
    //当 mounted 被调用时 vm.el 也在文档内。
  },

  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        console.log(this.$refs.form);
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    querySearch(queryString, cb, options) {
      var restaurants = options;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据

      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleSelect() {},
  },

  beforeUpdate() {
    //数据更新时调用，发生在虚拟 DOM 打补丁之前。这里适合在更新之前访问现有的 DOM，比如手动移除已添加的事件监听器。
    //该钩子在服务器端渲染期间不被调用，因为只有初次渲染会在服务端进行。
  },
  updated() {
    //由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    //当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
    //然而在大多数情况下，你应该避免在此期间更改状态。如果要相应状态改变，通常最好使用计算属性或 watcher 取而代之。
  },
  activated() {
    //被 keep-alive 缓存的组件激活时调用。
    //该钩子在服务器端渲染期间不被调用。
  },
  deactivated() {
    //被 keep-alive 缓存的组件停用时调用。
    //该钩子在服务器端渲染期间不被调用。
  },
  beforeUnmount() {
    //实例销毁之前调用。在这一步，实例仍然完全可用。
    //该钩子在服务器端渲染期间不被调用。
  },
  unmounted() {
    //实例销毁后调用。该钩子被调用后，对应 Vue 实例的所有指令都被解绑，所有的事件监听器被移除，所有的子实例也都被销毁。
    //该钩子在服务器端渲染期间不被调用。
  },
  errorCaptured() {
    //当捕获一个来自子孙组件的错误时被调用。
    //此钩子会收到三个参数：错误对象、发生错误的组件实例以及一个包含错误来源信息的字符串。
    //此钩子可以返回 false 以阻止该错误继续向上传播。
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
@import "@/assets/scss/box.scss";
.el-form.settings {
  width: 100%;
  padding: 8px 36px 17px 0;
  /deep/ .el-radio-group {
    margin-top: 7px !important;
  }
  /deep/ .el-form-item {
    width: 100%;
    padding: 0 0 0 18px;
    margin-bottom: 0;
    .el-form-item__label {
      min-height: 1px;
      margin-bottom: 0px;
      font-size: 12px;
      @include font_color("t_color_op1");
      padding: 0;
      line-height: 32px;
    }
    .el-form-item__content {
      margin-left: 0px !important;
      font-size: 12px;
      display: flex;
      align-items: center;
      flex-grow: 1;
      line-height: 32px;
      min-height: 32px;
      .el-select {
        @include select_base();
      }
      .el-input {
        @include input_base();
      }
      .el-textarea {
        @include textarea_base();
      }
      .el-checkbox {
        @include checkbox_base();
      }
    }
    .el-input__inner {
      width: 100% !important;
    }
    .el-input-group__prepend {
      border-color: rgba(245, 245, 245, 0.6) !important;
      color: rgba(255, 255, 255, 0.9) !important;
      background: none;
      padding: 0 10px;
    }
    &.btns {
      padding: 6px 0 0 89px;
      .el-form-item__content {
        width: auto;
        .el-button--primary {
          @include lheight(28);
          @include font_color("t_color_op1");
          @include background_color("t_color1_op2");
          @include border_color("t_color1_op2");
          padding: 0 15px;
          margin: 6px 16px 0 0;
          span {
            @include lheight(28);
            font-size: 12px;
            display: block;
            text-align: center;
          }
          &:hover {
            @include background_color("t_color1_op1");
            @include border_color("t_color1_op1");
          }
          &.is-disabled {
            // @include font_color("t_color_sc1");
            // @include background_color("t_color1_op3");
            @include border_color("t_color1_op3");
            background-color: rgba(42, 183, 255, 0.4) !important;
            color: rgba(255, 255, 255, 0.9) !important;
            &:hover {
              background-color: rgba(42, 183, 255, 0.4) !important;
            }
            span {
              background: none;
              // @include font_color("t_color_sc1");
            }
          }
        }
        .el-button--default {
          @include lheight(28);
          @include font_color("t_color_op2");
          @include background_color("t_color3_op2");
          @include border_color("t_color_op2");
          padding: 0 15px;
          margin: 6px 16px 0 6px;
          span {
            @include lheight(24);
            font-size: 12px;
            display: block;
            text-align: center;
          }
          &:hover {
            @include background_color("t_color3_op1");
            @include border_color("t_color_op1");
            @include font_color("t_color_op1");
          }
        }
      }
    }
    &:first-child {
      padding: 14px 0 0 18px;
    }
  }
  .main .el-form-item.btns {
    // padding: 0;
    // margin: 0;
    .el-form-item__content .el-button--primary {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px 20px;
    }
  }
  .rich {
    /deep/ .el-form-item__label {
      float: none;
    }
    /deep/ .el-form-item__content {
      width: 100% !important;
      margin: 0 !important;
    }
  }
}
/deep/.el-upload {
  display: block;
}
/deep/.el-tag {
  margin: 5px 0 2px 6px;
}
/deep/ .el-slider__button {
  width: 12px;
  height: 12px;
}
/deep/ .el-slider {
  width: 100%;
}
.flexRight {
  display: flex;
  padding: 20px 0px;
  margin-right: -16px;
  align-items: center !important;
  width: 100%;
  justify-content: flex-end;
}
/deep/ .el-range-editor.el-input__inner {
  padding: 0 10px;
  height: 32px;
  background: transparent;
  border-color: rgba(245, 245, 245, 0.6) !important;
  .el-range__icon {
    display: none;
  }
  .el-range__close-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
  }
  input {
    background: transparent;
    line-height: 12px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.9) !important;
    width: 45%;
  }
  .el-range-separator {
    width: 5%;
    color: rgba(255, 255, 255, 0.9) !important;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
/deep/ .el-form-item__error {
  padding-top: 2px;
}
/deep/ .el-cascader__tags .el-tag {
  max-width: 90px;
}
</style>
